import { Action, Dispatch } from 'redux';
import { UIMode } from '../../../../common/src/ts/types/UIMode';

export enum ToolbarDirection {
  VerticalLeft,
  Horizontal,
  VerticalRight,
}

export const UIMODE_SET_MODE = 'UIMODE_SET_MODE';
export const UIMODE_SET_TTS_MODE = 'UIMODE_SET_TTS_MODE';
export const UIMODE_SET_REGION_ZOOM_MODE = 'UIMODE_SET_REGION_ZOOM_MODE';
export const UIMODE_SET_TOOLBAR_DIRECTION = 'UIMODE_SET_TOOLBAR_DIRECTION';
export const UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS = 'UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS';

interface SetUIModeAction extends Action {
  type: typeof UIMODE_SET_MODE;
  mode: UIMode;
}

interface SetTTSModeAction extends Action {
  type: typeof UIMODE_SET_TTS_MODE;
  ttsMode: boolean;
}

interface SetRegionZoomModeAction extends Action {
  type: typeof UIMODE_SET_REGION_ZOOM_MODE;
  enabled: boolean;
}

interface SetToolbarDirectionAction extends Action {
  readonly type: typeof UIMODE_SET_TOOLBAR_DIRECTION;
  readonly toolbarDirection: ToolbarDirection;
}

interface SetPagesIgnorePointerEventsAction extends Action {
  readonly type: typeof UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS;
  enabled: boolean;
}

export type UIModeAction =
  SetUIModeAction | SetTTSModeAction | SetRegionZoomModeAction
  | SetToolbarDirectionAction | SetPagesIgnorePointerEventsAction;

export function isUIModeAction(action: Action): action is UIModeAction {
  switch (action.type) {
    case UIMODE_SET_MODE:
    case UIMODE_SET_TTS_MODE:
    case UIMODE_SET_REGION_ZOOM_MODE:
    case UIMODE_SET_TOOLBAR_DIRECTION:
    case UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS:
      return true;
    default:
      return false;
  }
}

export function setUIMode(mode: UIMode, dispatch: Dispatch<Action>): void {
  dispatch({ mode, type: UIMODE_SET_MODE });
  dispatch({ type: UIMODE_SET_REGION_ZOOM_MODE, enabled: false });
}

export function setTTSMode(ttsMode: boolean, dispatch: Dispatch<Action>): void {
  dispatch({ ttsMode, type: UIMODE_SET_TTS_MODE });
}

export function setRegionZoomMode(enabled: boolean, dispatch: Dispatch<Action>): void {
  dispatch({ enabled, type: UIMODE_SET_REGION_ZOOM_MODE });
}

export function setToolbarDirection(
  toolbarDirection: ToolbarDirection, dispatch: Dispatch<UIModeAction>,
): void {
  dispatch({ toolbarDirection, type: UIMODE_SET_TOOLBAR_DIRECTION });
}

export function setPagesIgnorePointerEvents(
  enabled: boolean, dispatch: Dispatch<UIModeAction>,
): void {
  dispatch({ enabled, type: UIMODE_SET_PAGES_IGNORE_POINTER_EVENTS });
}
